import { createApiClient } from '@titularis/api-client';

/**
 * O cliente da API: a tabela de preços e as Notícias Recentes.
 *
 * A landing lê `GET /billing/products`, que é público de propósito - o
 * comentário na rota diz o porquê: "a página de vendas precisa abrir para quem
 * ainda não tem conta". Então o preço que aparece aqui é o preço que o aluno
 * vai pagar, sem ninguém precisar lembrar de atualizar a página quando o valor
 * mudar.
 *
 * **Preço em página de vendas não se escreve à mão.** Número desatualizado numa
 * landing é promessa quebrada no checkout, e é o tipo de erro que a pessoa
 * conta para o grupo inteiro.
 */
/**
 * O endereço da API, exportado porque a meta da notícia precisa dele.
 *
 * A capa do cartão de prévia mora na API (`/news/{slug}/card`), e quem monta a
 * meta é uma função pura, sem acesso ao `import.meta.env` - ela recebe o
 * endereço de quem a chama. O cliente não expõe o `baseUrl` que recebeu, então
 * a constante é o caminho curto.
 */
/**
 * Em desenvolvimento, a API local; publicado, a de produção.
 *
 * **O padrão era a produção em qualquer ambiente**, e o app do aluno já fazia o
 * contrário (`?? 'http://localhost:3333'`). A diferença mordia sempre da mesma
 * forma: quem clonava o repositório e subia a landing sem criar o `.env` via a
 * tabela de preços falhar com "Não conseguimos carregar os preços agora" - a
 * chamada saía para `api.titularis.com.br`, que não autoriza `localhost` no
 * CORS. O sintoma acusava o produto; a causa era o padrão.
 */
export const urlDaApi =
  import.meta.env.VITE_API_URL ??
  (import.meta.env.DEV ? 'http://localhost:3333' : 'https://api.titularis.com.br');

export const api = createApiClient({ baseUrl: urlDaApi });

/**
 * A capa da notícia sai de uma rota nossa, e não de uma URL do bucket - o
 * porquê está no `newsImageUrl` do cliente, que passou a ser o dono da linha
 * quando a capa também foi parar na tela de início do aluno.
 */
export const urlDaCapa = (slug: string): string => api.newsImageUrl(slug);
